import styled from 'styled-components';

export const TermsWrapper = styled.div``;
